module.exports = __webpack_public_path__ + "img/registration-icon-white.cd54d67.svg";